module.exports = __webpack_public_path__ + "static/volunteer-61507cd2c3150ede6ad927ede1360f72.png";